import { useNavigate, useSearchParams } from "react-router-dom";
import TenantLeaseCard from "./TenantLeaseCard";
import TenantSynthese from "./TenantSynthese";
import TenantActionsPrioritaires from "./TenantActionsPrioritaires";
import TenantPayments from "./TenantPayments";
import TenantProfileList from "../Profile/TenantProfileList";
import HeaderTenant from "./HeaderTenant";
import DocumentShowList from "../File/DocumentShowList";
import MailLogs from "../Account/MailLogs";
// @ts-expect-error pure js
import { TenantStatus } from "../../models/tenant_old.js";
import ContentLayout from "../UI/Layout/ContentLayout.tsx";
import ModalDialog from "../UI/ModalDialog";
import RefuserCandidatModal from "./RefuserCandidatModal";
import CandidatSuiviCard from "./CandidatSuiviCard";
import CandidatPresentationCard from "../Candidat/CandidatPresentationCard";
import Text from "../UI/Text";
import Button from "../UI/Button";
import { Tabs } from "../UI/Tabs/Tabs";
import BulkQuittanceModal from "./Bulk/BulkQuittanceModal";
// @ts-expect-error pure js
import TenantAddForm from "./Forms/TenantAddForm";
// @ts-expect-error pure js
import { useModal } from "../../hooks/use-modal.jsx";
import { useEffect, useMemo, useState } from "react";
// @ts-expect-error pure js
import { ArrowDown, ArrowUp } from "../UI/Icons";
import style from "./TenantShow.module.css";
// @ts-expect-error pure js
import ActionsCourriers from "./ActionsCourriers";
import CardAction from "../UI/CardAction";
import EdlRealisation from "../Edl/EdlRealisation";
// @ts-expect-error pure js
import { ProfileStatus } from "../../models/profile";
// @ts-expect-error pure js
import { classnames } from "../../utils";
// @ts-expect-error pure js
import { isPropertyDisabled } from "../../utils/properties";
// @ts-expect-error pure js
import BlurOverlay from "../UI/BlurOverlay";
import DisabledBienNote from "../Property/DisabledBienNote";
import Processes from "../Processes/Processes";
import FinanceConfigList from "../Bank/FinanceConfigList";
// @ts-expect-error pure js
import { GLI_LINK } from "../../utils/constants/assurance";
// @ts-expect-error pure js
import useProperties from "../../hooks/use-properties";
// @ts-expect-error pure js
import { useTenantProfiles } from "../../hooks/use-profiles-indiv";
import { ChargesType, TenantLeaseType } from "../../utils/constants/tenants";
import PermissionScope from "../../store/PermissionScope";
import DashboardCard from "../UI/DashboardCard";
import Status from "../UI/Status";
import GuidedTour from "../GuidedTour/GuidedTour";
import {
  LOCATAIRE_GUIDE_ID,
  LOCATAIRE_GUIDE_STEPS,
} from "../GuidedTour/guides";
import useOnboarding from "../../hooks/use-onboarding";
import {
  IconAlertTriangle,
  IconCalendarOff,
  IconClipboardCheck,
  IconCurrencyEuro,
  IconPercentage,
  IconReceipt,
  IconShield,
  IconShieldCheck,
  IconStarFilled,
  IconTrash,
  IconUserCheck,
  IconUserPlus,
  IconUsers,
  IconUserX,
} from "@tabler/icons-react";
import {
  useTenantAccountBalance,
  useBalanceChargesRecuperables,
  // @ts-expect-error pure js
} from "../../hooks/use-balances";
import { calculateProrata } from "../../utils/balances";
import {
  formatEffortRate,
  getConfidenceNote,
  getEffortRate,
  getEffortRateColor,
  getHouseholdIncome,
} from "../../utils/candidature";
// @ts-expect-error pure js
import { currencyFormatter } from "../../api/Functions";
import Title from "../UI/Title.tsx";
import type { Tenant } from "../../models/tenant";
import type { Balance } from "../../models/balance";

interface BalanceTransaction {
  montant: number;
  date_transac?: string;
}

interface TenantShowProps {
  tenant: Tenant | null;
  balances: BalanceTransaction[];
  syncTransactionHandler: () => void;
  activerLocataire: () => void;
  activerCandidat: () => void;
  refuserCandidat: (notifyCandidat: boolean) => Promise<void>;
  supprimerCandidat: () => void;
}

export default function TenantShow({
  tenant,
  balances,
  syncTransactionHandler,
  activerLocataire,
  activerCandidat,
  refuserCandidat,
  supprimerCandidat,
}: TenantShowProps) {
  const nav = useNavigate();
  const { propertiesById, updatePropertyCles } = useProperties({
    withById: true,
  });
  const {
    structProfiles: profiles,
    archiveProfile,
    activateProfile,
    deleteProfile,
    inviteProfiles,
    revokeInviteProfiles,
  } = useTenantProfiles(tenant?.id);
  const { balances: balanceTenant } = useTenantAccountBalance(
    tenant?.id,
    false,
  );
  const { balanceRecuperables } = useBalanceChargesRecuperables(
    tenant?.id_bien,
    tenant?.id,
  );
  const chargesARegulariser = useMemo(
    () =>
      tenant
        ? (balanceRecuperables ?? []).reduce(
            (sum: number, balance: Balance) =>
              sum + Math.abs(calculateProrata(balance, tenant)),
            0,
          )
        : 0,
    [balanceRecuperables, tenant],
  );

  const [TenantAddModal, , openTenantAddModal] = useModal();
  const [isProcessOpen, setIsProcessOpen] = useState(false);
  const [isQuittanceModalOpen, setIsQuittanceModalOpen] = useState(false);
  const [refuserCandidatOpen, setRefuserCandidatOpen] = useState(false);
  const [edlOpen, setEdlOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [showArchivedProfiles, setShowArchivedProfiles] = useState(false);
  const [showCautionReminder, setShowCautionReminder] = useState(false);
  const { gating } = useOnboarding();

  useEffect(() => {
    if (searchParams.get("caution-reminder")) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowCautionReminder(true);
      setSearchParams((params: URLSearchParams) => {
        const newParams = new URLSearchParams(params);
        newParams.delete("caution-reminder");
        return newParams;
      });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (searchParams.get("action") === "edl") {
      setSearchParams((params: URLSearchParams) => {
        const newParams = new URLSearchParams(params);
        newParams.delete("action");
        return newParams;
      });
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setEdlOpen(true);
    }
  }, [searchParams, setSearchParams]);

  const archivedProfiles = profiles.filter(
    (profile: { status: number }) =>
      profile.status === ProfileStatus.Archive.status,
  );

  if (!tenant) return null;

  const property = propertiesById[tenant.id_bien];
  const disabledProperty = isPropertyDisabled(property);

  const isCandidat =
    tenant.status === TenantStatus.Candidat.status ||
    tenant.status === TenantStatus.CandidatArchive.status;
  const candidatProfiles = tenant.profiles.filter(
    (profile) =>
      profile.garantor_of === null &&
      profile.status === ProfileStatus.Actif.status,
  );
  const effortRate = getEffortRate(tenant, candidatProfiles);

  const vueEnsemble = (
    <div className={"container"}>
      <Processes
        open={isProcessOpen}
        onOpenChange={setIsProcessOpen}
        onFinish={() => setIsProcessOpen(false)}
        tenantId={tenant.id}
      />
      <BulkQuittanceModal
        open={isQuittanceModalOpen}
        onOpenChange={setIsQuittanceModalOpen}
        lockedTenantId={tenant.id}
      />
      <TenantAddForm tenant={tenant} modal={TenantAddModal} />
      <RefuserCandidatModal
        open={refuserCandidatOpen}
        onOpenChange={setRefuserCandidatOpen}
        onConfirm={refuserCandidat}
      />
      {tenant ? (
        <>
          {isCandidat && (
            <div className={style.dashboardCards}>
              <DashboardCard
                title="Revenus du foyer"
                value={currencyFormatter(getHouseholdIncome(candidatProfiles), {
                  withSymbol: false,
                  noDecimals: true,
                })}
                valueSuffix="€"
                subtitle={`Loyer charges comprises : ${currencyFormatter(
                  (tenant.loyer_hc ?? 0) + (tenant.charges ?? 0),
                )}`}
                icon={IconUsers}
                iconColor="info"
              />
              <DashboardCard
                title="Taux d'effort"
                value={effortRate === null ? "–" : formatEffortRate(effortRate)}
                subtitle={
                  effortRate === null
                    ? "Revenus non renseignés"
                    : "Part du loyer charges comprises dans les revenus du foyer"
                }
                icon={IconPercentage}
                iconColor={
                  effortRate === null
                    ? "orange"
                    : getEffortRateColor(effortRate)
                }
              />
              <DashboardCard
                title="Indice de confiance"
                value={getConfidenceNote({
                  tenant,
                  profiles: candidatProfiles,
                  propertyGli: property?.gli,
                })}
                valueSuffix="/5"
                subtitle={
                  property?.gli
                    ? "Bien couvert par une GLI : la garantie du candidat n'est pas prise en compte"
                    : "Revenus, situation professionnelle et garantie"
                }
                icon={IconStarFilled}
                iconColor="violet"
              />
            </div>
          )}
          {isCandidat && (
            <div className={style.candidatCards}>
              <CandidatSuiviCard tenant={tenant} />
              <CandidatPresentationCard profiles={candidatProfiles} />
            </div>
          )}

          {/* Dashboard Cards */}
          {tenant.status !== TenantStatus.Candidat.status &&
            tenant.status !== TenantStatus.CandidatArchive.status &&
            balanceTenant && (
              <div className={style.dashboardCards}>
                <DashboardCard
                  title="Solde"
                  value={currencyFormatter(balanceTenant.balance, {
                    withSymbol: false,
                  })}
                  valueSuffix="€"
                  subtitle={
                    <Status
                      color={balanceTenant.balance >= 0 ? "success" : "danger"}
                      text={balanceTenant.balance >= 0 ? "À jour" : "En retard"}
                    />
                  }
                  icon={IconCurrencyEuro}
                  iconColor="success"
                />
                <DashboardCard
                  title="Somme des loyers perçus"
                  value={currencyFormatter(balanceTenant.debits, {
                    withSymbol: false,
                  })}
                  valueSuffix="€"
                  subtitle=""
                  icon={IconCurrencyEuro}
                  iconColor="info"
                />
                <DashboardCard
                  title="Dépôt de garantie"
                  value={`${Math.round(balanceTenant.dg_debit)}`}
                  valueSuffix={`/${Math.round(-balanceTenant.dg_credit)}€`}
                  subtitle={
                    <Status
                      color={
                        balanceTenant.dg_debit >= -balanceTenant.dg_credit
                          ? "success"
                          : "danger"
                      }
                      text={
                        balanceTenant.dg_debit >= -balanceTenant.dg_credit
                          ? "Complet"
                          : "Incomplet"
                      }
                    />
                  }
                  icon={IconShieldCheck}
                  iconColor="violet"
                />
                {tenant.type_charge === ChargesType.PROVISION && (
                  <DashboardCard
                    title="Charges à régulariser"
                    value={currencyFormatter(chargesARegulariser, {
                      withSymbol: false,
                      noDecimals: true,
                    })}
                    valueSuffix="€"
                    subtitle="Charges récupérables non encore refacturées"
                    icon={IconReceipt}
                    iconColor="orange"
                  />
                )}
              </div>
            )}

          <div className={style.raccourcisSection}>
            <Title
              variant="deca"
              weight="bold"
              as="h2"
              className={style.sectionTitle}
            >
              Mes raccourcis
            </Title>
            <div className={style.raccourcisGrid}>
              {tenant.status === TenantStatus.Actif.status && (
                <>
                  <CardAction
                    icon={IconReceipt}
                    title={
                      tenant.is_type_quittance
                        ? "Générer une quittance"
                        : "Générer une facture acquittée"
                    }
                    onClick={() => setIsQuittanceModalOpen(true)}
                    requiresWrite
                  />
                  <CardAction
                    icon={IconClipboardCheck}
                    title="Réaliser un état des lieux"
                    onClick={() => setEdlOpen(true)}
                    requiresWrite
                  />
                  <CardAction
                    icon={IconAlertTriangle}
                    title={
                      tenant.is_type_quittance
                        ? "Avis d'échéance"
                        : "Générer une facture"
                    }
                    onClick={() =>
                      nav(
                        `/bailleur/tenants/${tenant?.id}?tab-tenant-show=actions&action=courrier&avenant-type=avis_echeance`,
                      )
                    }
                    requiresWrite
                  />
                  <CardAction
                    icon={IconCalendarOff}
                    title="Fin de bail"
                    onClick={() => setIsProcessOpen(true)}
                    requiresWrite
                  />
                </>
              )}
              {tenant.status === TenantStatus.Archive.status && (
                <>
                  <CardAction
                    icon={IconReceipt}
                    title={
                      tenant.is_type_quittance
                        ? "Générer une quittance"
                        : "Générer une facture acquittée"
                    }
                    onClick={() => setIsQuittanceModalOpen(true)}
                    requiresWrite
                  />
                  <CardAction
                    icon={IconUserCheck}
                    title="Réactiver le locataire"
                    onClick={activerLocataire}
                    requiresWrite
                  />
                  <CardAction
                    icon={IconAlertTriangle}
                    title={
                      tenant.is_type_quittance
                        ? "Avis d'échéance"
                        : "Générer une facture"
                    }
                    onClick={() =>
                      nav(
                        `/bailleur/tenants/${tenant?.id}?tab-tenant-show=actions&action=courrier&avenant-type=avis_echeance`,
                      )
                    }
                    requiresWrite
                  />
                </>
              )}
              {tenant.status === TenantStatus.Candidat.status && (
                <>
                  <CardAction
                    icon={IconUserPlus}
                    title="Convertir en locataire"
                    onClick={openTenantAddModal}
                    requiresWrite
                  />
                  <CardAction
                    icon={IconUserX}
                    title="Refuser le dossier"
                    onClick={() => setRefuserCandidatOpen(true)}
                    requiresWrite
                  />
                  {TenantLeaseType.isHabitation(tenant.lease_type) && (
                    <CardAction
                      icon={IconShield}
                      title="Assurance loyers impayés"
                      onClick={() => window.open(GLI_LINK, "_blank")}
                    />
                  )}
                </>
              )}
              {tenant.status === TenantStatus.CandidatArchive.status && (
                <>
                  <CardAction
                    icon={IconUserPlus}
                    title="Convertir en locataire"
                    onClick={openTenantAddModal}
                    requiresWrite
                  />
                  <CardAction
                    icon={IconUserCheck}
                    title="Réactiver le candidat"
                    onClick={activerCandidat}
                    requiresWrite
                  />
                  <CardAction
                    icon={IconTrash}
                    title="Supprimer le candidat"
                    onClick={supprimerCandidat}
                    requiresWrite
                  />
                </>
              )}
            </div>
          </div>

          {/* Synthèse et Paramètres du bail */}
          {tenant.status !== TenantStatus.Candidat.status &&
            tenant.status !== TenantStatus.CandidatArchive.status && (
              <>
                <div className={style.cardsRow}>
                  <TenantActionsPrioritaires tenant={tenant} />
                  <TenantSynthese tenant={tenant} />
                </div>
                <TenantLeaseCard
                  tenant={tenant}
                  allowEdit
                  propertyType={property?.type}
                  propertyTypeIndice={property?.type_indice}
                />
              </>
            )}
          <TenantProfileList
            profiles={profiles.filter(
              (profile: { status: number }) =>
                profile.status === ProfileStatus.Actif.status,
            )}
            editProfileHandler={(profileId: number) => nav(`${profileId}/edit`)}
            addRepresentantProfileHandler={(profileId: number) =>
              nav(`${profileId}/add_representant`)
            }
            archiveProfileHandler={archiveProfile}
            inviteProfileHandler={(profileId: number) =>
              inviteProfiles([profileId])
            }
            revokeInviteProfileHandler={(profileId: number) =>
              revokeInviteProfiles([profileId])
            }
            removeGarant={deleteProfile}
            removeRepresentant={deleteProfile}
            isCandidat={
              tenant.status === TenantStatus.Candidat.status ||
              tenant.status === TenantStatus.CandidatArchive.status
            }
          />
          {archivedProfiles.length > 0 && (
            <div
              className={classnames(
                style.archivedProfiles,
                "border-blue primaryText",
              )}
              onClick={() => setShowArchivedProfiles((profile) => !profile)}
            >
              <p>Afficher les profils archivés</p>
              <p>{showArchivedProfiles ? <ArrowUp /> : <ArrowDown />}</p>
            </div>
          )}
          {showArchivedProfiles && (
            <TenantProfileList
              profiles={archivedProfiles}
              editProfileHandler={(profileId: number) =>
                nav(`${profileId}/edit`)
              }
              addRepresentantProfileHandler={(profileId: number) =>
                nav(`${profileId}/add_representant`)
              }
              activateProfileHandler={activateProfile}
              removeGarant={deleteProfile}
              removeRepresentant={deleteProfile}
              isCandidat={
                tenant.status === TenantStatus.Candidat.status ||
                tenant.status === TenantStatus.CandidatArchive.status
              }
              title="Profils archivés"
            />
          )}
        </>
      ) : (
        <p>Aucun profil trouvé</p>
      )}
    </div>
  );

  return (
    <PermissionScope profileId={property?.id_profile_nom_owner}>
      <EdlRealisation
        tenant={tenant}
        property={property}
        updatePropertyCles={updatePropertyCles}
        open={edlOpen}
        onOpenChange={setEdlOpen}
        onSubmitted={() => setEdlOpen(false)}
      />
      <ModalDialog
        size="xs"
        open={showCautionReminder}
        header="Acte de cautionnement à prévoir"
        subtitle="Le bail prévoit un ou plusieurs garants physiques."
        onOpenChange={setShowCautionReminder}
      >
        <div className={style.cautionReminder}>
          <Text>
            Une fois le bail signé, pensez à générer et faire signer l'acte de
            cautionnement depuis les actions du locataire. Un rappel a été
            ajouté à vos actions prioritaires.
          </Text>
          <Button onClick={() => setShowCautionReminder(false)}>
            J'ai compris
          </Button>
        </div>
      </ModalDialog>
      <GuidedTour
        guideId={LOCATAIRE_GUIDE_ID}
        steps={LOCATAIRE_GUIDE_STEPS}
        run={
          gating &&
          tenant.status !== TenantStatus.Candidat.status &&
          !disabledProperty
        }
      />
      <ContentLayout
        header={tenant && <HeaderTenant tenant={tenant} property={property} />}
        body={
          <Tabs id="tenant-show" defaultValue="vue-ensemble">
            <div className="container bg-blue paddingT10 border-blue">
              <div className="content">
                <Tabs.List>
                  <Tabs.Tab
                    value="vue-ensemble"
                    dataTour="locataire-tab-general"
                  >
                    Général
                  </Tabs.Tab>
                  {tenant?.status !== TenantStatus.Candidat.status &&
                    !disabledProperty && (
                      <>
                        <Tabs.Tab
                          value="historique-transactions"
                          dataTour="locataire-tab-paiements"
                        >
                          Paiements
                        </Tabs.Tab>
                        <Tabs.Tab
                          value="documents-courriers"
                          dataTour="locataire-tab-documents"
                        >
                          Documents
                        </Tabs.Tab>
                        <Tabs.Tab
                          value="emails"
                          dataTour="locataire-tab-emails"
                        >
                          Emails
                        </Tabs.Tab>
                        <Tabs.Tab
                          value="actions"
                          dataTour="locataire-tab-actions"
                        >
                          Actions
                        </Tabs.Tab>
                        <Tabs.Tab
                          value="parametres-banque"
                          dataTour="locataire-tab-parametres"
                        >
                          Paramètres
                        </Tabs.Tab>
                      </>
                    )}
                </Tabs.List>
              </div>
            </div>
            <div className="blueSpace"></div>
            <div className="content" style={{ position: "relative" }}>
              <div inert={disabledProperty ? true : undefined}>
                <Tabs.Panel value="vue-ensemble">{vueEnsemble}</Tabs.Panel>
                {tenant?.status !== TenantStatus.Candidat.status && (
                  <>
                    <Tabs.Panel value="historique-transactions">
                      <TenantPayments
                        tenant={tenant}
                        syncTransactionHandler={syncTransactionHandler}
                      />
                    </Tabs.Panel>
                    <Tabs.Panel value="documents-courriers">
                      <div className={"w-100"}>
                        <DocumentShowList
                          tenant={tenant}
                          allowDelete
                          allowEdit
                          isBailleur
                        />
                      </div>
                    </Tabs.Panel>
                    <Tabs.Panel value="emails">
                      <MailLogs
                        tenantId={tenant.id}
                        tenantDebut={tenant.debut}
                      />
                    </Tabs.Panel>
                    <Tabs.Panel value="actions">
                      <ActionsCourriers
                        tenant={tenant}
                        property={property}
                        balances={balances}
                        updatePropertyCles={updatePropertyCles}
                      />
                    </Tabs.Panel>
                    <Tabs.Panel value="parametres-banque">
                      <FinanceConfigList tenantId={tenant?.id} />
                    </Tabs.Panel>
                  </>
                )}
              </div>
              {disabledProperty && (
                <BlurOverlay className={style.overlay}>
                  <DisabledBienNote className={style.disabledNote} />
                </BlurOverlay>
              )}
            </div>
          </Tabs>
        }
      />
    </PermissionScope>
  );
}
